export default __webpack_public_path__ + "static/viinitie-banner-wedding-mobile.6cfe7c4ef66dbd7477c82fdec79314b6.jpg";